import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import * as actions from 'actions'
import LocationDescription from './LocationDescription'
import assets from 'modules/assets'
import * as parse from 'modules/parse'

class Location extends Component {
  constructor(props) {
    super(props)
    this.state = {
      locId: 1,
      shouldDisplay: false,
      data: props.data
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    })
  }
  toggleTroupeDescription = (locId) => {
    this.setState({
      locId: locId,
      shouldDisplay: this.props.troupe === 'B'
    })
  }
  render() {
    let p = parse
    let troupe, ActivityTitleA, LocA, ActivityTitleB, LocB, ActivityTitleC, LocC,
        flag1, flag2, flag3
    if (this.state && this.state.data) {
      let d = this.state.data
      if (this.props.troupe === 'A') {
        troupe = d['troupe-a']
        ActivityTitleA = d['activity-title-a-a']
        LocA = p.addSpaces(d['loc-a-a'])
        ActivityTitleB = d['activity-title-a-b']
        LocB = p.addSpaces(d['loc-a-b'])
        ActivityTitleC = d['activity-title-a-c']
        LocC = p.addSpaces(d['loc-a-c'])
        flag1 = assets('images/Flags-France.png')
        flag2 = assets('images/Flags-France.png')
        flag3 = assets('images/Flags-Japan.png')
      } else {
        troupe = d['troupe-b']
        ActivityTitleA = d['activity-title-b-a']
        LocA = p.addSpaces(d['loc-b-a'])
        ActivityTitleB = d['activity-title-b-b']
        LocB = p.addSpaces(d['loc-b-b'])
        ActivityTitleC = d['activity-title-b-c']
        LocC = p.addSpaces(d['loc-b-c'])
        flag1 = assets('images/Flags-France.png')
        flag2 = assets('images/Flags-Romania.png')
        flag3 = assets('images/Flags-Indonesia.png')
      }
    }

    return (
      <div>
        <section className="main-grid center">
          <ul className="grid group">
            <h6 className="grid-section-title">{troupe}</h6>

            <li className="grid-small grid-troupes mg-bottom">
              <div className="flag-row group">
                <img src={flag1}></img>
                <img className="arrow" src={assets('images/Arrow.png')} />
              </div>
              <h3>{ActivityTitleA}</h3>
              <h2 className="grid-troupes-title" onClick={this.toggleTroupeDescription.bind(this, 1)}>{LocA}</h2>
            </li>

            <li className="grid-small grid-middle grid-troupes mg-bottom">
              <div className="flag-row group">
                <img src={flag2}></img>
                <img className="arrow" src={assets('images/Arrow.png')} />
              </div>
              <h3>{ActivityTitleB}</h3>
              <h2 className="grid-troupes-title" onClick={this.toggleTroupeDescription.bind(this, 2)}>{LocB}</h2>
            </li>

            <li className="grid-small grid-troupes mg-bottom">
              <div className="flag-row group">
                <img src={flag3}></img>
              </div>
              <h3>{ActivityTitleC}</h3>
              <h2 className="grid-troupes-title" onClick={this.toggleTroupeDescription.bind(this, 3)}>{LocC}</h2>
            </li>
          </ul>
        </section>

        <LocationDescription data={this.state.data} troupe={this.props.troupe} locId={this.state.locId} shouldDisplay={this.state.shouldDisplay}/>
      </div>
    )
  }
}
Location.contextTypes = {
}
Location.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location
  }
}

export default connect(mapStateToProps)(Location)



// WEBPACK FOOTER //
// ./src/components/Utils/Location.js